import { render, staticRenderFns } from "./VMajorMedicalInsurancePatientSelector.vue?vue&type=template&id=1837b104&"
import script from "./VMajorMedicalInsurancePatientSelector.vue?vue&type=script&lang=js&"
export * from "./VMajorMedicalInsurancePatientSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports